// eslint-disable-next-line no-unused-vars
import React from 'react';
import styled from 'styled-components';

const ContainerContent = styled.div`
  background-image: url(/assets/ui/container-big-bg.png);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100% 100%;
  height: auto;
  color: var(--secondary-text-color);
  padding: 2rem;
  padding-top: 3rem;
`;

const LoginContent = styled.div`
  list-style: none;
  padding: 0;
  font-size: 11pt;
  color: #58516c !important;
`;

const ContainerContentComponent = ({children, withLoginContent = false}) => {
  return (
    <ContainerContent>
      {withLoginContent ? <LoginContent>{children}</LoginContent> : children}
    </ContainerContent>
  );
};

export default ContainerContentComponent;
